<template>
    <div v-if="src" class="vehicle-thumbnail" :style="{ 'background-image': `url('${src}')` }"></div>
</template>

<script>
export default {
  name: 'VehicleThumbnail',
  props: {
    src: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss">
.vehicle-thumbnail {
    width: 100%;
    height: 100px;
    max-width: 200px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50% 50%;
}
</style>
